import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";

import { Providers } from "@/providers";
import { App } from "./App";
import "./globals.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element in index.html");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <Providers>
        <App />
      </Providers>
    </BrowserRouter>
  </React.StrictMode>
);
